import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';

export const reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory();
const clickPlugin = new ClickAnalyticsPlugin();

export const appInsights = new ApplicationInsights({
    config: {
        connectionString:
            process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
            [clickPlugin.identifier]: { autoCapture: true },
        },
        disableExceptionTracking: false,
        disableAjaxTracking: false,
        enableUnhandledPromiseRejectionTracking: true,
        enableAutoRouteTracking: true,
        autoTrackPageVisitTime: true,
        enableDebug: true,
    },
});

let isAppInsightsInitialized = false;

export const initializeAppInsights = () => {
    if (!isAppInsightsInitialized) {
        if (process.env.NODE_ENV === 'production') {
            appInsights.loadAppInsights();
            appInsights.trackPageView();
            isAppInsightsInitialized = true;
        }
    }
};
